import { render, staticRenderFns } from "./LabNewsDetails.vue?vue&type=template&id=043225b2"
import script from "./LabNewsDetails.vue?vue&type=script&lang=js"
export * from "./LabNewsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports